import { Loader } from '@googlemaps/js-api-loader';

let _promise: Promise<typeof google> | null = null;
const HUB_URL = (import.meta.env.VITE_HUB_URL as string | undefined) ?? '';

async function fetchKey(): Promise<string> {
  if (!HUB_URL) throw new Error('VITE_HUB_URL not set');
  const r = await fetch(`${HUB_URL}/restaurants/maps-key/`);
  if (!r.ok) throw new Error(`maps-key fetch failed: ${r.status}`);
  const data = (await r.json()) as { browser_key?: string };
  if (!data.browser_key) {
    throw new Error('Google Maps key not configured on ignite-hub (GOOGLE_KEY env var)');
  }
  return data.browser_key;
}

export async function loadGoogleMaps(): Promise<typeof google> {
  // If Maps is already on the window (e.g., Playwright stub or a prior load
  // outside this SPA), reuse — no need to re-fetch the key or re-inject the
  // script tag.
  if (typeof window !== 'undefined' && (window as { google?: typeof google }).google?.maps) {
    return (window as { google: typeof google }).google;
  }
  if (_promise) return _promise;
  _promise = (async () => {
    const apiKey = await fetchKey();
    const loader = new Loader({ apiKey, libraries: ['places'], region: 'FR' });
    return loader.load();
  })();
  return _promise;
}
